export enum FilmRibbonsLabels {
  dimensions = "dimensions",
  material = "material",
  print = "print",
}
